// assets
import { DashboardOutlined, UserOutlined, ReadOutlined, CustomerServiceOutlined } from '@ant-design/icons';

// project imports
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'stories',
      title: 'Stories',
      type: 'item',
      url: '/stories',
      icon: ReadOutlined,
      breadcrumbs: false
    },
    {
      id: 'support-tickets',
      title: 'Support Tickets',
      type: 'item',
      url: '/support-tickets',
      icon: CustomerServiceOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
